export interface SearchTransactionsResponse {
  pageContent: TransactionResult[];
  totalResults: number;
  totalPages: number;
  customerId?: string;
}

export interface TransactionResult {
  transactionType: TlogTransactionType;
  businessDayUtc: string;
  employeeIds: string[];
  employeeNames: string[];
  endTransactionDateTimeUtc: string;
  closeDateTimeUtc: string;
  grandAmount: number;
  siteInfoId: string;
  tlogId: string;
  touchPointId: string;
  isTrainingMode: boolean;
  transactionNumber: string;
  isVoided: boolean;
  isSuspended: boolean;
  itemCount: number;
  transactionCategory: string;
  receivedDateTimeUtc: string;
}

export interface TransactionSearchDto {
  siteInfoIds?: string[];
  touchPointId?: string;
  transactionNumber?: string;
  businessDayUtc?: Date;
  fromTransactionDateTimeUtc?: TransactionDateTime;
  toTransactionDateTimeUtc?: TransactionDateTime;
  itemProductIds?: string[];
  customerId?: string;
  isSuspended?: boolean;
  isVoided?: boolean;
  transactionTypes?: TlogTransactionType[];
  pageNumber?: number;
  pageSize?: number;
  loyaltyCard?: string;
  isTrainingMode?: boolean;
}

export interface TransactionDateTime {
  dateTime: string;
  originalOffset: string;
}

export enum TlogTransactionType {
  SALES = 'SALES',
  RETURN = 'RETURN',
  SIGN_ON = 'SIGN_ON',
  SIGN_OFF = 'SIGN_OFF',
  START_OF_DAY = 'START_OF_DAY',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  TERMINAL_LOCK = 'TERMINAL_LOCK',
  TERMINAL_UNLOCK = 'TERMINAL_UNLOCK',
  DRAWER_OPEN = 'DRAWER_OPEN',
  END_OF_DAY = 'END_OF_DAY',
  TERMINAL_UP = 'TERMINAL_UP',
  TERMINAL_DOWN = 'TERMINAL_DOWN',
  SECURITY_ID_ENABLED = 'SECURITY_ID_ENABLED',
  SECURITY_ID_DISABLED = 'SECURITY_ID_DISABLED',
  DRAWER_ASSIGNMENT = 'DRAWER_ASSIGNMENT',
  DRAWER_RETURN = 'DRAWER_RETURN',
  CONFIRMATION = 'CONFIRMATION',
  COUNT = 'COUNT',
  OPEN_LOAN = 'OPEN_LOAN',
  ADD_LOAN = 'ADD_LOAN',
  SAFE_DROP = 'SAFE_DROP',
  PAY_IN = 'PAY_IN',
  PAY_OUT = 'PAY_OUT',
  BANK_DEPOSIT = 'BANK_DEPOSIT',
  BANK_RECEIPT = 'BANK_RECEIPT',
  TRANSFER = 'TRANSFER',
  PRICE_CHANGE = 'PRICE_CHANGE',
  UNKNOWN = 'UNKNOWN',
  BLIND_PICKUP = 'BLIND_PICKUP',
  TENDER_EXCHANGE = 'TENDER_EXCHANGE',
}
